import {httpService} from "@/modules/common/services";

const getMatterPackages = async (uid, matterUid) => {
  try {
    const fetchMatterPackages = (pageIndex = 1, perPage = 100) => { return httpService.get(`platform/v1/clients/${uid}/payment/client_packages`, {matter_uid: matterUid, per_page: perPage, page: pageIndex}).then(res => res.data.client_packages); }
    let pageIndex = 1, perPage = 100;
    let matterPackcagesFullList = [], matterPackages = await fetchMatterPackages(pageIndex++, perPage);
    matterPackcagesFullList.push(...matterPackages);
    while (matterPackages.length === perPage){
      matterPackages = await fetchMatterPackages(pageIndex++, perPage);
      matterPackcagesFullList = matterPackcagesFullList.concat(matterPackages);
    }
    return {packages: matterPackcagesFullList};
  }
  catch (error) {
    return {error: error};
  }
};

const getPackages = async (params = {}) => {
  const res = await httpService.get(`platform/v1/payment/packages`, params);
  if (res.status === "Error") {
    return {error: res.error};
  } else {
    return {packages: res.data.packages};
  }
};

const getAllPackages = async (onPageLoaded = null) => {
  let pageIndex = 1, perPage = 100;
  let packagesFullList = [], packages = (await getPackages({page: pageIndex++, per_page: perPage})).packages;
  packagesFullList.push(...packages.filter(p => p.active));

  while (packages.length === perPage){
    if (typeof onPageLoaded === 'function') {
      onPageLoaded(packagesFullList);
    }
    packages = (await getPackages({page: pageIndex++, per_page: perPage})).packages;
    packagesFullList = packagesFullList.concat(packages.filter(p => p.active));
  }

  if (typeof onPageLoaded === 'function') {
    onPageLoaded(packagesFullList);
  }
  return packagesFullList;
}

const createClientPackage = (params = {}) => {
  return httpService.post('/platform/v1/payment/client_packages', params)
}

export default {
  getMatterPackages,
  getPackages,
  getAllPackages,
  createClientPackage,
}
